/**
 * Custom Product Bundle JavaScript (ES5)
 * Handles dynamic pricing, image switching, and cart functionality
 */

function CustomProductBundle(container) {
  this.container = container;
  this.sectionId = container.dataset.sectionId;

  // Load configuration from JSON
  // NOTE: No semicolon inside JSON.parse() — that was a bug in the original
  this.config = JSON.parse(
    document.getElementById('product-config-' + this.sectionId).textContent
  );

  // Initialize state
  this.state = {
    packSize: null,
    quantity: 1,
    isBaseProductView: true
  };

  // Cache DOM elements
  this.elements = {
    packSizeBtns: container.querySelectorAll('[data-option="pack-size"]'),
    qtyInput: container.querySelector('.qty-input'),
    qtyMinus: container.querySelector('.qty-btn.minus'),
    qtyPlus: container.querySelector('.qty-btn.plus'),
    priceDisplay: container.querySelector('#product-price .price-amount'),
    comparePriceDisplay: container.querySelector('#product-price .compare-price-amount'),
    savePriceDisplay: container.querySelector('#product-price .save-price-amount'),    
    priceBreakdown: container.querySelector('#price-breakdown'),
    mainImage: container.querySelector('#main-product-image'),
    thumbItems: container.querySelectorAll('.thumb-item'),
    thumbnailsContainer: container.querySelector('.thumbnail-list'),
    addToCartBtn: container.querySelector('#add-to-cart-btn'),
    loadingSpinner: container.querySelector('.loading-spinner')
  };

  // Bound reference for thumb click handler
  this.thumbClickHandler = null;

  this.init();
}

/**
 * Initialize
 */
CustomProductBundle.prototype.init = function () {
  this.bindEvents();
  this.initializeGallery();
  this.setDefaultSelections();
  this.initThumbnailSlider();
  this.updateDisplay();
  this.initSwipeGesture();
};

  // // Initialize Mobile Gallery Swiper
  CustomProductBundle.prototype.initSwipeGesture = function() {
    const isMobile = () => window.innerWidth < 740;

    const mainImageContainer = this.elements.mainImage.parentElement;

    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    const SWIPE_THRESHOLD = 50;
    const VERTICAL_LOCK = 75;

    mainImageContainer.addEventListener('touchstart', (e) => {
      if (!isMobile()) return; // ← Guard

      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    mainImageContainer.addEventListener('touchend', (e) => {
      if (!isMobile()) return; // ← Guard

      touchEndX = e.changedTouches[0].clientX;
      touchEndY = e.changedTouches[0].clientY;

      const deltaX = touchEndX - touchStartX;
      const deltaY = Math.abs(touchEndY - touchStartY);

      if (deltaY > VERTICAL_LOCK) return;
      if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

      if (deltaX < 0) {
        this.navigateImage('next');
      } else {
        this.navigateImage('prev');
      }
    }, { passive: true });
  }


  CustomProductBundle.prototype.navigateImage = function(direction) {
    // Get only currently visible/relevant thumbs
    const visibleThumbs = [...this.elements.thumbItems].filter(thumb => {
      // If it's a combination thumb, only include if it's currently shown
      if (thumb.dataset.imageType === 'combination') {
        return !thumb.closest('.hidden') && thumb.offsetParent !== null;
      }
      return true;
    });

    const activeIndex = visibleThumbs.findIndex(thumb =>
      thumb.classList.contains('active')
    );

    let nextIndex;

    if (direction === 'next') {
      nextIndex = activeIndex < visibleThumbs.length - 1
        ? activeIndex + 1
        : 0; // Loop back to first
    } else {
      nextIndex = activeIndex > 0
        ? activeIndex - 1
        : visibleThumbs.length - 1; // Loop to last
    }

    const targetThumb = visibleThumbs[nextIndex];
    if (targetThumb) {
      this.handleThumbClick(targetThumb);
      this.scrollThumbnailIntoView(targetThumb); // Keep thumb strip in sync
    }
  }

  CustomProductBundle.prototype.scrollThumbnailIntoView = function(thumb) {
    // Smoothly scroll the thumbnail strip so active thumb is visible
    thumb.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

/**
 * Initialize thumbnail slider navigation
 */
CustomProductBundle.prototype.initThumbnailSlider = function () {
  var self = this;
  var sliderComponent = this.container.querySelector('slider-component');

  if (sliderComponent) {
    var prevBtn = sliderComponent.querySelector('.slider-button--prev');
    var nextBtn = sliderComponent.querySelector('.slider-button--next');
    var sliderContainer = sliderComponent.querySelector('.slider');

    if (prevBtn && nextBtn && sliderContainer) {
      var step = parseInt(prevBtn.dataset.step) || 3;
      var scrollDistance = step * 120;

      prevBtn.addEventListener('click', function () {
        sliderContainer.scrollLeft -= scrollDistance;
        self.updateSliderButtonStates(sliderContainer, prevBtn, nextBtn);
      });

      nextBtn.addEventListener('click', function () {
        sliderContainer.scrollLeft += scrollDistance;
        self.updateSliderButtonStates(sliderContainer, prevBtn, nextBtn);
      });

      // Initial button state
      this.updateSliderButtonStates(sliderContainer, prevBtn, nextBtn);

      // Update button states on scroll
      sliderContainer.addEventListener('scroll', function () {
        self.updateSliderButtonStates(sliderContainer, prevBtn, nextBtn);
      });
    }
  }
};

/**
 * Update slider button disabled states based on scroll position
 */
CustomProductBundle.prototype.updateSliderButtonStates = function (container, prevBtn, nextBtn) {
  var isAtStart = container.scrollLeft <= 0;
  var isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 5;

  prevBtn.disabled = isAtStart;
  nextBtn.disabled = isAtEnd;

  prevBtn.classList.toggle('is-disabled', isAtStart);
  nextBtn.classList.toggle('is-disabled', isAtEnd);
};

/**
 * Initialize gallery with base product images on page load
 */
CustomProductBundle.prototype.initializeGallery = function () {
  if (this.config.baseProductImages && this.config.baseProductImages.length > 0) {
    this.updateThumbnailsGallery(this.config.baseProductImages, 'base');
    this.state.isBaseProductView = true;
  }
};

/**
 * Update thumbnails gallery with images
 */
CustomProductBundle.prototype.updateThumbnailsGallery = function (images, type) {
  // Default parameter replacement
  if (type === undefined) { type = 'base'; }

  if (!this.elements.thumbnailsContainer) return;

  // Clear existing thumbnails
  this.elements.thumbnailsContainer.innerHTML = '';

  // Create thumbnail elements
  for (var i = 0; i < images.length; i++) {
    var image = images[i];
    var isFirst = i === 0;

    var div = document.createElement('div');
    div.className = 'thumb-item thumbnail-list__item slider__slide' + (isFirst ? ' active' : '');
    div.dataset.imageSrc = image.src;
    div.dataset.imageAlt = image.alt;
    div.dataset.imageType = type;

    var img = document.createElement('img');
    img.width = 'auto';
    img.height = 'auto';
    img.src = image.src;
    img.alt = image.alt;
    img.loading = 'lazy';

    div.appendChild(img);
    this.elements.thumbnailsContainer.appendChild(div);
  }

  // Re-cache thumb items since DOM changed
  this.elements.thumbItems = this.container.querySelectorAll('.thumb-item');

  // Re-bind thumbnail click events
  this.bindThumbnailEvents();
  this.initThumbnailSlider();
};

/**
 * Set default selections (first option in each group)
 */
CustomProductBundle.prototype.setDefaultSelections = function () {
  if (this.elements.packSizeBtns.length > 0) {
    this.state.packSize = this.elements.packSizeBtns[0].dataset.value;
    this.elements.packSizeBtns[0].classList.add('active');
  }
};

/**
 * Bind all event listeners
 */
CustomProductBundle.prototype.bindEvents = function () {
  var self = this;

  // Pack size buttons
  this.elements.packSizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      self.handleOptionChange(e, 'packSize');
    });
  });

  // Quantity controls
  this.elements.qtyMinus.addEventListener('click', function () {
    self.decreaseQuantity();
  });
  this.elements.qtyPlus.addEventListener('click', function () {
    self.increaseQuantity();
  });
  this.elements.qtyInput.addEventListener('change', function (e) {
    self.handleQuantityChange(e);
  });

  // Thumbnail clicks
  this.bindThumbnailEvents();

  // Add to cart
  this.elements.addToCartBtn.addEventListener('click', function () {
    self.addToCart();
  });
};

/**
 * Bind thumbnail click events
 */
CustomProductBundle.prototype.bindThumbnailEvents = function () {
  var self = this;

  this.elements.thumbItems.forEach(function (thumb) {
    // Remove old handler if exists
    if (thumb._thumbClickHandler) {
      thumb.removeEventListener('click', thumb._thumbClickHandler);
    }
    // Assign new handler stored on element to allow clean removal
    thumb._thumbClickHandler = function () {
      self.handleThumbClick(thumb);
    };
    thumb.addEventListener('click', thumb._thumbClickHandler);
  });
};

/**
 * Handle option button clicks
 */
CustomProductBundle.prototype.handleOptionChange = function (event, stateKey) {
  var button = event.currentTarget;
  var value = button.dataset.value;

  // Update state
  this.state[stateKey] = value;

  // Update button active states
  var group = button.closest('.option-group');
  group.querySelectorAll('.option-btn').forEach(function (btn) {
    btn.classList.remove('active');
  });
  button.classList.add('active');

  // Update display
  this.updateDisplay();
};

/**
 * Decrease quantity
 */
CustomProductBundle.prototype.decreaseQuantity = function () {
  var currentQty = parseInt(this.elements.qtyInput.value);
  if (currentQty > 1) {
    this.elements.qtyInput.value = currentQty - 1;
    this.state.quantity = currentQty - 1;
    this.updatePrice();
  }
};

/**
 * Increase quantity
 */
CustomProductBundle.prototype.increaseQuantity = function () {
  var currentQty = parseInt(this.elements.qtyInput.value);
  var maxQty = parseInt(this.elements.qtyInput.max) || 10;
  if (currentQty < maxQty) {
    this.elements.qtyInput.value = currentQty + 1;
    this.state.quantity = currentQty + 1;
    this.updatePrice();
  }
};

/**
 * Handle manual quantity input
 */
CustomProductBundle.prototype.handleQuantityChange = function (event) {
  var qty = parseInt(event.target.value);
  var min = parseInt(event.target.min) || 1;
  var max = parseInt(event.target.max) || 10;

  if (isNaN(qty) || qty < min) { qty = min; }
  if (qty > max) { qty = max; }

  event.target.value = qty;
  this.state.quantity = qty;
  this.updatePrice();
};

/**
 * Handle thumbnail click
 */
CustomProductBundle.prototype.handleThumbClick = function (thumb) {
  var self = this;
  var imageUrl = thumb.dataset.imageSrc;
  var imageAlt = thumb.dataset.imageAlt;

  this.elements.mainImage.style.opacity = '0';
  setTimeout(function () {
    self.elements.mainImage.src = imageUrl;
    self.elements.mainImage.alt = imageAlt;
    self.elements.mainImage.style.opacity = '1';
  }, 150);

  this.elements.thumbItems.forEach(function (item) {
    item.classList.remove('active');
  });
  thumb.classList.add('active');
};

/**
 * Update all displays (price, image)
 */
CustomProductBundle.prototype.updateDisplay = function () {
  this.updatePrice();
  this.updateImage();
};

/**
 * Calculate and update price display
 */
CustomProductBundle.prototype.updatePrice = function () {
  var self = this;

  if (!this.state.packSize) { return; }

  var totalPrice = 0;
  var breakdown = [];
  var packMultiplier = this.state.packSize === 'pair' ? 1 : 1;
  var quantity = this.state.quantity || 1;
  var finalMultiplier = packMultiplier * quantity;
  var comparePrice = 0;
  var savePrice;

  if (this.state.packSize === 'single') {
    var basePrice = this.config.baseProductPrice;
    comparePrice = this.config.baseProductComparePrice;
    savePrice = this.config.baseProductSavePrice;
    var baseTitle = this.config.baseProductTitle;
    totalPrice += basePrice;
    breakdown.push({
      name: baseTitle,
      price: basePrice,
      quantity: finalMultiplier
    });
  } else if (this.state.packSize === 'pair') {
    var pairPrice = this.config.pairProductPrice;
    comparePrice = this.config.pairProductComparePrice;
    savePrice = this.config.pairProductSavePrice;
    var pairTitle = this.config.pairProductTitle;
    totalPrice += pairPrice;
    breakdown.push({
      name: pairTitle,
      price: pairPrice,
      quantity: finalMultiplier
    });
  }

  // Update price display
  this.elements.priceDisplay.textContent = this.formatPrice(totalPrice);  
  this.elements.priceDisplay.dataset.price = totalPrice;
  console.log("SavePrice =>", savePrice);
  if(savePrice == "null" || savePrice == '' || savePrice == undefined){
    console.log("Save Price is emplty")
    this.elements.comparePriceDisplay.classList.add('hidden');
    this.elements.savePriceDisplay.classList.add('hidden');
  }else{
    this.elements.comparePriceDisplay.classList.remove('hidden');
    this.elements.savePriceDisplay.classList.remove('hidden');    
  }

  this.elements.comparePriceDisplay.textContent = this.formatPrice(comparePrice);  
  this.elements.comparePriceDisplay.dataset.compareprice = comparePrice; 
  
  this.elements.savePriceDisplay.textContent = savePrice;  
  this.elements.savePriceDisplay.dataset.saveprice = savePrice;   
  

  // Update price breakdown if element exists
  if (this.elements.priceBreakdown) {
    this.elements.priceBreakdown.innerHTML = breakdown.map(function (item) {
      return '<div class="price-breakdown-item">' +
        '<span>' + item.name + '</span>' +
        '</div>';
    }).join('');
  }
};

/**
 * Update main image based on current selection
 */
CustomProductBundle.prototype.updateImage = function () {
  var self = this;

  if (!this.state.packSize) { return; }

  // Find matching combination (ES5 — no Array.find)
  var combination = null;
  for (var i = 0; i < this.config.combinations.length; i++) {
    if (this.config.combinations[i].packSize === this.state.packSize) {
      combination = this.config.combinations[i];
      break;
    }
  }

  if (combination && combination.image) {
    this.state.isBaseProductView = false;

    this.elements.mainImage.style.opacity = '0';
    setTimeout(function () {
      self.elements.mainImage.src = combination.image;
      self.elements.mainImage.alt = combination.packSize;
      self.elements.mainImage.style.opacity = '1';
    }, 150);

    this.updateThumbnailsGallery(this.config.baseProductImages, 'base');
  }
};

/**
 * Add products to cart with correct SKUs based on selections
 * Uses Promise chain instead of async/await
 */
CustomProductBundle.prototype.addToCart = function () {
  var self = this;

  if (!this.state.packSize) {
    alert('Please select all options before adding to cart.');
    return;
  }

  // Show loading state
  this.elements.addToCartBtn.disabled = true;
  if (this.elements.loadingSpinner) {
    this.elements.loadingSpinner.classList.remove('hidden');
  }

  var items = this.buildCartItems();

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(function (response) {
    if (!response.ok) {
      return response.json().then(function (errData) {
        throw new Error(errData.description || 'Failed to add to cart');
      });
    }
    return response.json();
  })
  .then(function (result) {
    console.log('Added to cart:', result);
    self.showSuccessMessage();
    // window.location.href = '/checkout';
    monster_refresh(open);
  })
  .catch(function (error) {
    console.error('Add to cart error:', error);
    alert('Error adding to cart: ' + error.message);
  })
  .then(function () {
    // finally block equivalent
    self.elements.addToCartBtn.disabled = false;
    if (self.elements.loadingSpinner) {
      self.elements.loadingSpinner.classList.add('hidden');
    }
  });
};

/**
 * Build cart items array based on current selection
 */
CustomProductBundle.prototype.buildCartItems = function () {
  var items = [];
  var packMultiplier = this.state.packSize === 'pair' ? 1 : 1;
  var quantity = this.state.quantity || 1;
  var finalQuantity = packMultiplier * quantity;

  if (this.state.packSize === 'single') {
    items.push({
      id: this.config.baseProductId,
      quantity: finalQuantity,
      properties: this.buildLineItemProperties()
    });
  } else if (this.state.packSize === 'pair') {
    items.push({
      id: this.config.pairProductId,
      quantity: finalQuantity,
      properties: this.buildLineItemProperties()
    });
  }

  return items;
};

/**
 * Build line item properties for cart items
 */
CustomProductBundle.prototype.buildLineItemProperties = function () {
  var properties = {};
  if (this.state.packSize) {
    properties['Pack Size'] = this.state.packSize;
  }
  return properties;
};

/**
 * Show success message
 */
CustomProductBundle.prototype.showSuccessMessage = function () {
  var self = this;
  var btnText = this.elements.addToCartBtn.querySelector('.btn-text');
  var originalText = btnText.textContent;

  btnText.textContent = '✓ ADDED TO CART';
  this.elements.addToCartBtn.style.background = '#4CAF50';

  setTimeout(function () {
    btnText.textContent = originalText;
    self.elements.addToCartBtn.style.background = '';
  }, 2000);
};

/**
 * Format price in dollars
 */
CustomProductBundle.prototype.formatPrice = function (cents) {
  return '$' + (cents / 100).toFixed(2);
};

// ------------------------------------
// Initialize when DOM is ready
// ------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  var bundleSections = document.querySelectorAll('[data-section-type="custom-product-bundle"]');
  bundleSections.forEach(function (section) {
    new CustomProductBundle(section);
  });
});

// Re-initialize on Shopify section events (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="custom-product-bundle"]');
    if (section) {
      new CustomProductBundle(section);
    }
  });
}
